import { useSelector } from 'react-redux';

export const useAutomationPermissions = ({
  objectId,
  isClient,
  canEditEntity,
}: {
  objectId?: string;
  isClient?: boolean;
  canEditEntity: boolean;
}): {
  canStart: boolean;
  canManage: boolean;
} => {
  const access = useSelector((s: any) => s.authentication.access);

  const canStartContactAutomations = Boolean(
    access?.contacts?.single_record_actions?.record_layout_start_automation
  );
  const canStartCustomObjectAutomations = Boolean(
    objectId &&
      access?.custom_objects?.custom_object_entities?.[objectId]
        ?.single_record_actions?.record_layout_start_automation
  );

  const hasStartAutomationsPermission = isClient
    ? canStartContactAutomations
    : canStartCustomObjectAutomations;

  return {
    canStart: hasStartAutomationsPermission && canEditEntity,
    canManage: canEditEntity,
  };
};
